import React from 'react';
import './ErrorMessage.css';

interface ErrorMessageProps {
  message: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <div className="error-message">
      <span className="error-icon">⚠️</span>
      <p className="error-text">{message}</p>
    </div>
  );
};
